import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useAgency'

import type { AgencyModel } from '@models/types'

interface AgencyListItemProps {
  agency: AgencyModel,
}

const Agency = (props: AgencyListItemProps) => {
  const { agency, agency: { id, title } } = props

  const { editAgencyUrl } = generateUrls(agency, { prefixRoute: `agencies/${id}/manage` })

  return (
    <DashboardModuleListItem
      href={editAgencyUrl}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {`# ${id}`}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default Agency
